import { AppState } from "../../../redux-configuration/AppState";

export const paymentSessionIdSelector = (appState: AppState): string | undefined => appState.payment.retrieveSession.sessionId
export const retrievePaymentSessionLoadingSelector = (appState: AppState): boolean => appState.payment.retrieveSession.loading
export const retrievePaymentSessionErrorSelector = (appState: AppState): string | undefined => appState.payment.retrieveSession.error
